import { render, staticRenderFns } from "./deltime.vue?vue&type=template&id=15a27dad&scoped=true"
import script from "./deltime.vue?vue&type=script&lang=js"
export * from "./deltime.vue?vue&type=script&lang=js"
import style0 from "./deltime.vue?vue&type=style&index=0&id=15a27dad&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "15a27dad",
  null
  
)

export default component.exports